import React from 'react';
import PropTypes from 'prop-types';
import {
	BaseLevelTableRow,
	BaseLevelItem,
	MainItem,
	CaretIconWrapper,
	BaseLevelGreyItem,
	BaseLevelDetailItem,
	BaseLevelRightItem,
} from './style/base_level_style';
import {CaretIcon} from '../../../icons/caret-icon/caret_icon';

export const BaseLevelRow = ({
	isLastRow,
	isExpanded,
	mainItem,
	enabledColumns,
	showBottom,
	stickyTopPosition,
	isVisible,
	baseLevelItems,
	baseLevelRightItems,
	baseLevelDetailItems,
	baseLevelGreyItems,
	numberOfParents,
}) => {
	const show = () => {
		//look on task_row on defaultProps
		//call this function "onToggleExpand / onShow / anything with on. This tells that is a callback"
		showBottom();
	};

	const list = [];
	let index = 0;
	if (isVisible) {
		//add the caret icon to the list
		if (enabledColumns.caretIcon !== undefined && enabledColumns.caretIcon !== 0) {
			list.push(
				<CaretIconWrapper order={enabledColumns.caretIcon} key={index}>
					<CaretIcon
						size={CaretIcon.SIZE.STANDARD}
						color={'#000'}
						direction={isExpanded === true && CaretIcon.DIRECTION.UP}
					/>
				</CaretIconWrapper>
			);
			//write index++ directly in the key
			index++;
		}

		//add the main item to the list
		if (enabledColumns.mainItem !== undefined && enabledColumns.mainItem !== 0) {
			list.push(
				<MainItem key={index} order={enabledColumns.mainItem}>
					<span>{mainItem}</span>
				</MainItem>
			);
			index++;
		}

		if (baseLevelItems) {
			//looping through the base level items
			for (const key of Object.keys(baseLevelItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BaseLevelItem order={enabledColumns[key]} key={index}>
							<span>{baseLevelItems[key]}</span>
						</BaseLevelItem>
					);
					index++;
				}
			}
		}

		if (baseLevelRightItems) {
			//looping through the base level items
			for (const key of Object.keys(baseLevelRightItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BaseLevelRightItem order={enabledColumns[key]} key={index}>
							<span>{baseLevelRightItems[key]}</span>
						</BaseLevelRightItem>
					);
					index++;
				}
			}
		}

		if (baseLevelDetailItems) {
			//looping through the base level detailitems
			for (const key of Object.keys(baseLevelDetailItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BaseLevelDetailItem order={enabledColumns[key]} key={index}>
							<span>{baseLevelDetailItems[key]}</span>
						</BaseLevelDetailItem>
					);
					index++;
				}
			}
		}

		if (baseLevelGreyItems) {
			//looping through the base level grey items
			for (const key of Object.keys(baseLevelGreyItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BaseLevelGreyItem order={enabledColumns[key]} key={index}>
							<span>{baseLevelGreyItems[key]}</span>
						</BaseLevelGreyItem>
					);
					index++;
				}
			}
		}
	}

	return (
		<>
			<BaseLevelTableRow
				isExpanded={isExpanded}
				numberOfParents={numberOfParents}
				onClick={isExpanded !== undefined ? show : () => {}}
				isLastRow={isLastRow}
				stickyTopPosition={stickyTopPosition}
			>
				{list}
				{/* {isVisible && enabledColumns.caretIcon !== undefined && enabledColumns.caretIcon !== 0 && (
					<CaretIconWrapper order={enabledColumns.caretIcon}>
						<CaretIcon size={CaretIcon.SIZE.STANDARD} color={'#000'} direction={isExpanded === true && CaretIcon.DIRECTION.UP} />
					</CaretIconWrapper>
				)}

				{isVisible && enabledColumns.mainItem !== undefined && enabledColumns.mainItem !== 0 && (
					<MainItem order={enabledColumns.mainItem}>
						<span>{mainItem}</span>
					</MainItem>
				)}
				{isVisible && enabledColumns.reportedTime && (
					<BaseLevelItem order={enabledColumns.reportedTime}>
						<span title={reportedTime}>{reportedTime}</span>
					</BaseLevelItem>
				)}

				{isVisible && enabledColumns.notes !== undefined && enabledColumns.notes !== 0 && (
					<BaseLevelItem order={enabledColumns.notes}>
						<span>{notes}</span>
					</BaseLevelItem>
				)}
				{isVisible && enabledColumns.date !== undefined && enabledColumns.date !== 0 && (
					<BaseLevelItem order={enabledColumns.date}>
						<span>{date}</span>
					</BaseLevelItem>
				)}
				{isVisible && enabledColumns.personIcon !== undefined && enabledColumns.personIcon !== 0 && (
					<BaseLevelItem order={enabledColumns.personIcon}>
						<span>{personIcon ? <HexagonText text={personIcon.fullName} imgUrl={personIcon.imageUrl} /> : ' '}</span>
					</BaseLevelItem>
				)}

				{isVisible && enabledColumns.roleName !== undefined && enabledColumns.roleName !== 0 && <BaseLevelItem order={enabledColumns.roleName}>{roleName ? <span>{roleName}</span> : ' '}</BaseLevelItem>}
				{isVisible && enabledColumns.departmentName !== undefined && enabledColumns.departmentName !== 0 && <BaseLevelItem order={enabledColumns.departmentName}>{departmentName ? <span>{departmentName}</span> : ' '}</BaseLevelItem>}
				{isVisible && enabledColumns.clientName !== undefined && enabledColumns.clientName !== 0 && <BaseLevelItem order={enabledColumns.clientName}>{clientName ? <span>{clientName}</span> : ' '}</BaseLevelItem>}
				{isVisible && enabledColumns.projectName !== undefined && enabledColumns.projectName !== 0 && <BaseLevelItem order={enabledColumns.projectName}>{projectName ? <span>{projectName}</span> : ' '}</BaseLevelItem>}
				{isVisible && enabledColumns.taskName !== undefined && enabledColumns.taskName !== 0 && <BaseLevelItem order={enabledColumns.taskName}>{taskName ? <span>{taskName}</span> : ' '}</BaseLevelItem>}
				{isVisible && enabledColumns.timeRegType !== undefined && enabledColumns.timeRegType !== 0 && <BaseLevelGreyItem order={enabledColumns.timeRegType}>{timeRegType ? <span>{timeRegType}</span> : ' '}</BaseLevelGreyItem>}
				{isVisible && enabledColumns.timeRegDetail !== undefined && enabledColumns.timeRegDetail !== 0 && <BaseLevelDetailItem order={enabledColumns.timeRegDetail}>{timeRegDetail ? <span>{timeRegDetail}</span> : ' '}</BaseLevelDetailItem>}
				{isVisible && enabledColumns.billable !== undefined && enabledColumns.billable !== 0 && <BaseLevelItem order={enabledColumns.billable}>{billable}</BaseLevelItem>}
				{isVisible && enabledColumns.price !== undefined && enabledColumns.price !== 0 && <BaseLevelItem order={enabledColumns.price}> {price ? <span>{price}</span> : ' '}</BaseLevelItem>}
				{isVisible && enabledColumns.cost !== undefined && enabledColumns.cost !== 0 && <BaseLevelItem order={enabledColumns.cost}> {cost ? <span>{cost}</span> : ' '}</BaseLevelItem>} */}
			</BaseLevelTableRow>
		</>
	);
};

BaseLevelRow.propTypes = {
	isLastRow: PropTypes.bool,
	isExpanded: PropTypes.bool,
	reportedTime: PropTypes.string,
	assigneesElement: PropTypes.object,
	projectName: PropTypes.string,
	roleName: PropTypes.string,
	price: PropTypes.string,
	cost: PropTypes.string,
	notes: PropTypes.string,
	taskName: PropTypes.string,
	personIcon: PropTypes.object,
	timeRegType: PropTypes.string,
	showBottom: PropTypes.func,
	stickyTopPosition: PropTypes.number,
	projectIcon: PropTypes.object,
	timeRegDetail: PropTypes.string || PropTypes.object,
	date: PropTypes.string,
	departmentName: PropTypes.string,
	clientName: PropTypes.string,
	billable: PropTypes.string,
	mainItem: PropTypes.object,
	isVisible: PropTypes.object,
	baseLevelItems: PropTypes.object,
	baseLevelDetailItems: PropTypes.object,
	baseLevelGreyItems: PropTypes.object,
	baseLevelHexagonItems: PropTypes.object,
	baseLevelRightItems: PropTypes.object,
	numberOfParents: PropTypes.number,

	enabledColumns: PropTypes.shape({
		projectIcon: PropTypes.bool,
		caretIcon: PropTypes.bool,
		personIcon: PropTypes.bool,
		personName: PropTypes.bool,
		reportedTime: PropTypes.bool,
		timeRegType: PropTypes.bool,
		timeRegDetail: PropTypes.bool,
		projectName: PropTypes.bool,
		roleName: PropTypes.bool,
		price: PropTypes.bool,
		cost: PropTypes.bool,
		date: PropTypes.bool,
		notes: PropTypes.bool,
		taskName: PropTypes.bool,
		showBottom: PropTypes.bool,
		departmentName: PropTypes.bool,
		clientName: PropTypes.bool,
		billable: PropTypes.bool,
		mainItem: PropTypes.bool,
	}).isRequired,
};
